import type { GetAllRequestParameters } from '@pct-ng/core/dto';
import { AbstractDtoService } from '@pct-ng/core/dto';
import {
  type PartnerGetDTO,
  type PartnerListDTO,
  type PartnerPostDTO,
  type PartnerPutDTO,
  PartnerService,
} from '@szebit-app/sdk/backend';
import { Injectable } from '@angular/core';
import type { HttpContext } from '@angular/common/http';
import type { ListPaginatedDTO } from '@pct-sdk/core';
import { map, type Observable } from 'rxjs';
import { isNil } from '@pct-ts/typeguard';

@Injectable()
export class PartnerDtoService extends AbstractDtoService<
  PartnerService,
  PartnerPostDTO,
  PartnerGetDTO,
  PartnerListDTO,
  'id',
  PartnerPutDTO
> {
  constructor() {
    super({ sort: 'name', direction: 'ASC' }, PartnerService);
  }

  override create(dto: PartnerPostDTO, httpContext?: HttpContext): Observable<PartnerGetDTO> {
    // TODO backendnek szolni adja vissza
    return this.service
      .createPartner(dto, httpContext)
      .pipe(map(() => dto as unknown as PartnerGetDTO));
  }

  override update(
    id: string,
    dto: PartnerPutDTO,
    httpContext?: HttpContext,
  ): Observable<PartnerGetDTO> {
    // TODO backendnek szolni adja vissza
    return this.service.updatePartner(id, dto, httpContext);
  }

  override delete(id: string, httpContext?: HttpContext): Observable<void> {
    return this.service.deletePartner(id, httpContext);
  }

  override getById(id: string, httpContext?: HttpContext): Observable<PartnerGetDTO> {
    return this.service.findPartner(id, httpContext);
  }

  override getAll(
    { pagination, sort }: GetAllRequestParameters<any>,
    httpContext?: HttpContext,
  ): Observable<ListPaginatedDTO<PartnerListDTO, any>> {
    return this.service.listPartners(
      sort?.field,
      // eslint-disable-next-line sonarjs/no-nested-conditional
      sort?.order === undefined ? undefined : sort?.order === 'asc' ? 'Asc' : 'Desc',
      pagination?.size,
      pagination?.page,
      httpContext,
    );
  }

  listPublic(): Observable<PartnerListDTO[]> {
    return this.service.listPublic();
  }

  override getDtoId(dto: PartnerGetDTO): string;
  override getDtoId(dto: PartnerGetDTO | null | undefined): string | null | undefined;
  override getDtoId(dto: Partial<PartnerGetDTO> | null | undefined): string | null | undefined;
  override getDtoId(
    dto: PartnerGetDTO | Partial<PartnerGetDTO> | null | undefined,
  ): string | null | undefined {
    if (isNil(dto)) {
      return dto;
    }
    return dto.id;
  }

  override toString(dto: PartnerGetDTO): string {
    return dto.name ?? 'UNKNOWN ITEM';
  }
}
